declare namespace $ {

	type $shm_surreal_table__profile_id_shm_hitalama_map_widget_float_surreal_table_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_surreal_table['profile_id'] >
		,
		ReturnType< $shm_surreal_table['profile_id'] >
	>
	type $shm_surreal_table__table_name_shm_hitalama_map_widget_float_surreal_table_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_surreal_table['table_name'] >
		,
		ReturnType< $shm_surreal_table['table_name'] >
	>
	type $shm_surreal_table__columns_shm_hitalama_map_widget_float_surreal_table_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_surreal_table['columns'] >
		,
		ReturnType< $shm_surreal_table['columns'] >
	>
	type $shm_surreal_table__search_fields_shm_hitalama_map_widget_float_surreal_table_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_surreal_table['search_fields'] >
		,
		ReturnType< $shm_surreal_table['search_fields'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_float_surreal_table_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_surreal_table['table_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_surreal_table_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_surreal_table_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_surreal_table['Table_input'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_textarea__value_shm_hitalama_map_widget_float_surreal_table_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_surreal_table['columns_text'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__hint_shm_hitalama_map_widget_float_surreal_table_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_textarea['hint'] >
	>
	type $mol_labeler__title_shm_hitalama_map_widget_float_surreal_table_10 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_map_widget_float_surreal_table_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_surreal_table['Columns_input'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $shm_surreal_profile_form__profile_id_shm_hitalama_map_widget_float_surreal_table_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_surreal_table['profile_id'] >
		,
		ReturnType< $shm_surreal_profile_form['profile_id'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_float_surreal_table_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	export class $shm_hitalama_map_widget_float_surreal_table extends $shm_hitalama_map_widget_float {
		profile_id( ): string
		table_name( ): string
		columns( ): readonly(any)[]
		search_fields( ): readonly(any)[]
		Table( ): $shm_surreal_table
		Table_input( ): $mol_string
		Table_label( ): $mol_labeler
		Columns_input( ): $mol_textarea
		Columns_label( ): $mol_labeler
		Connection( ): $shm_surreal_profile_form
		Settings( ): $mol_list
		head_showed( ): boolean
		columns_text( next?: string ): string
		content( ): readonly(any)[]
		settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map